module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/professional_tip_en-6569d4e3.png";